import { Filter, FilterX, X } from "lucide-react";
import { fleetrifyIcons } from "../../assets/icons/icons";
import { FleetrifyButton } from "../Button/customButton";
import FleetrifyDatePicker from "../Datepicker/datePicker";
import FleetrifyCustomSelect from "../Dropdown/customSelect";
import FleetrifyTooltip from "../Tooltip/tooltip";

const FleetrifyFilter = ({
  searchPlaceholder,
  searchValue,
  onSearchChange,
  noSearch,
  statusValue,
  onStatusChange,
  onLocationChange,
  statusOption,
  locationOption,
  locationValue,
  planOption,
  onPlanChange,
  planvalue,
  transactOption,
  onTransactChange,
  transactValue,
  paymentOption,
  onPaymentChange,
  companyValue,
  companyOption,
  onCompanyChange,
  paymentValue,
  selectedStartDate,
  onStartDateChange,
  createBtn,
  onCreate,
  dateRangeFilter,
  nameOption,
  onNameChange,
  nameValue,
  countryOption,
  onCountryChange,
  countryValue,
  roleOption,
  onRoleChange,
  roleValue,
  className,
  searchInputClass,
  searchWrapClass,
  selectWrapClass,
  onActivityChange,
  activityValue,
  activityOption,
  dateRangeLabel,
  isFilterDisabled,
  onFilterClick,
  onClearFilter,
  serviceOption,
  serviceValue,
  onServiceChange,
  // loading props
  isLoadingRoles,
}: {
  searchPlaceholder?: string;
  searchValue?: string;
  onSearchChange: (value: string) => void;
  noSearch?: boolean;
  statusLabel?: string;
  statusValue?: any;
  onStatusChange?: any;
  onLocationChange?: any;
  statusOption?: any[];
  locationOption?: any[];
  locationValue?: any;
  planOption?: any[];
  onPlanChange?: any;
  planvalue?: any;
  transactOption?: any[];
  onTransactChange?: any;
  transactValue?: any;
  paymentOption?: any[];
  onPaymentChange?: any;
  paymentValue?: any;
  selectedStartDate?: any;
  onStartDateChange?: any;
  createBtn?: boolean;
  dateRangeFilter?: boolean;
  nameOption?: any[];
  onNameChange?: any;
  nameValue?: any;
  roleOption?: any[];
  onRoleChange?: any;
  roleValue?: any;
  onCreate?: () => void;
  className?: string;
  searchInputClass?: string;
  searchWrapClass?: string;
  selectWrapClass?: string;
  companyValue?: any;
  companyOption?: any[];
  onCompanyChange?: any;
  countryOption?: any[];
  onCountryChange?: any;
  countryValue?: any;
  onActivityChange?: any;
  activityValue?: any;
  activityOption?: any;
  dateRangeLabel?: string;
  isFilterDisabled?: boolean;
  onFilterClick?: () => void;
  onClearFilter?: () => void;
  serviceOption?: any[];
  serviceValue?: any;
  onServiceChange?: any;
  // loading props
  isLoadingRoles?: boolean;
}) => {
  return (
    <section
      className={`py-10 flex gap-10 overflow-x-auto hide-scrollbar justify-between items-center ${className}`}
    >
      <form className="flex flex-row  gap-10 items-center w-full">
        {!noSearch && (
          <div
            className={`grid relative place-items-center ${searchWrapClass}`}
          >
            <input
              type="text"
              placeholder={searchPlaceholder || "Search company’s name or ID"}
              value={searchValue}
              className={`${searchInputClass} w-[400px] text-sm pl-7 font-medium outline-none placeholder:text-[#828282] placeholder:text-sm border-none rounded-[30px] bg-[#FFFFFF] px-4 py-2`}
              onChange={(e) => onSearchChange(e.target.value)}
            />

            {searchValue ? (
              <button
                type="button"
                onClick={() => onSearchChange("")}
                className="absolute right-6 text-gray-500 hover:text-gray-700"
              >
                <X size={16} />
              </button>
            ) : (
              <figure className="absolute right-6">
                {fleetrifyIcons.filterSearchIcon}
              </figure>
            )}
          </div>
        )}
        <div className="flex gap-4 items-center">
          <p className="text-[#333333] text-xs min-w-fit font-bold">
            Filter By:
          </p>

          {serviceOption && onServiceChange && (
            <FleetrifyCustomSelect
              selectWrapClass={selectWrapClass}
              value={serviceValue!}
              onChange={onServiceChange}
              options={serviceOption || []}
              placeholder="Service type"
              width="min-w-fit w-full"
            />
          )}
          {nameOption && onNameChange && (
            <FleetrifyCustomSelect
              selectWrapClass={selectWrapClass}
              value={nameValue!}
              onChange={onNameChange}
              options={nameOption || []}
              placeholder="Name"
              width="min-w-fit w-full"
            />
          )}
          {roleOption && onRoleChange && (
            <FleetrifyCustomSelect
              selectWrapClass={selectWrapClass}
              value={roleValue!}
              onChange={onRoleChange}
              options={roleOption || []}
              placeholder="Role"
              width="min-w-fit w-full"
              loading={isLoadingRoles}
            />
          )}
          {statusOption && onStatusChange && (
            <FleetrifyCustomSelect
              selectWrapClass={selectWrapClass}
              value={statusValue!}
              onChange={onStatusChange}
              options={statusOption || []}
              placeholder="Status"
              width="min-w-fit w-full"
            />
          )}
          {planOption && onPlanChange && (
            <FleetrifyCustomSelect
              selectWrapClass={selectWrapClass}
              value={planvalue!}
              onChange={onPlanChange}
              options={planOption || []}
              placeholder="Plan Type"
              width="min-w-fit w-full"
            />
          )}
          {transactOption && onTransactChange && (
            <FleetrifyCustomSelect
              selectWrapClass={selectWrapClass}
              value={transactValue!}
              onChange={onTransactChange}
              options={transactOption || []}
              placeholder="Transaction Type"
              width="min-w-fit w-full"
            />
          )}
          {paymentOption && onPaymentChange && (
            <FleetrifyCustomSelect
              selectWrapClass={selectWrapClass}
              value={transactValue!}
              onChange={onPaymentChange}
              options={paymentOption || []}
              placeholder="Payment Method"
              width="min-w-fit w-full"
            />
          )}
          {locationOption && onLocationChange && (
            <FleetrifyCustomSelect
              selectWrapClass={selectWrapClass}
              value={locationValue!}
              onChange={onLocationChange}
              options={locationOption || []}
              placeholder="Location"
              width="min-w-fit w-full"
            />
          )}
          {companyOption && onCompanyChange && (
            <FleetrifyCustomSelect
              selectWrapClass={selectWrapClass}
              value={companyValue!}
              onChange={onCompanyChange}
              options={companyOption || []}
              placeholder="Company"
              width="min-w-fit w-full"
            />
          )}
          {countryOption && onCountryChange && (
            <FleetrifyCustomSelect
              selectWrapClass={selectWrapClass}
              value={countryValue!}
              onChange={onCountryChange}
              options={countryOption || []}
              placeholder="Country"
              width="min-w-fit w-full"
            />
          )}
          {activityOption && onActivityChange && (
            <FleetrifyCustomSelect
              selectWrapClass={selectWrapClass}
              value={activityValue!}
              onChange={onActivityChange}
              options={activityOption || []}
              placeholder="Activity type"
              width="min-w-fit w-full"
            />
          )}

          {dateRangeFilter && (
            <>
              <div className="flex gap-4 min-w-fit  items-center">
                <p className="text-[#333333]  text-xs font-medium">
                  {dateRangeLabel || "Expiration Date Range:"}
                </p>
              </div>
              <div className="w-full flex gap-4 items-center ">
                <FleetrifyDatePicker
                  // label="Pick a Date"
                  value={selectedStartDate}
                  onChange={onStartDateChange}
                  placeholder="Start date"
                  width="w-[200px]"
                />
                <FleetrifyDatePicker
                  // label="Pick a Date"
                  value={selectedStartDate}
                  onChange={onStartDateChange}
                  placeholder="End date"
                  width="w-[200px]"
                />
              </div>
            </>
          )}
          <FleetrifyTooltip content="Filter" position="right">
            <button
              onClick={onFilterClick}
              type="button"
              className={`hover:bg-gray-100 border-none p-1 transition-all duration-300 rounded-lg ${isFilterDisabled ? "cursor-not-allowed" : ""
                }`}
              disabled={isFilterDisabled}
            >
              <Filter className="text-[#143887] h-5 w-5" />
            </button>
          </FleetrifyTooltip>
          <FleetrifyTooltip content="Clear Filter" position="right">
            <button
              onClick={onClearFilter}
              type="button"
              className={`hover:bg-gray-100 border-none p-1 transition-all duration-300 rounded-lg ${isFilterDisabled ? "cursor-not-allowed" : ""
                }`}
              disabled={isFilterDisabled}
            >
              <FilterX className="text-[#143887] h-5 w-5" />
            </button>
          </FleetrifyTooltip>
        </div>
      </form>
      {createBtn && (
        <div>
          <FleetrifyButton
            size="small"
            className="bg-[#143887] flex w-full gap-3 items-center"
            onClick={onCreate!}
          >
            <figure>{fleetrifyIcons.addUserIcon}</figure>
            <p className="text-sm min-w-fit">Add User</p>
          </FleetrifyButton>
        </div>
      )}
    </section>
  );
};

export default FleetrifyFilter;
